import { useGetWhatsNewFeatures } from '@dhl/receiver-preference-api'
import { isFeatureEnabled } from '~/config/index.js'

export const useAgreedPlacePhotoInteraction = () => {
  const { refetch: getWhatsNewFeatures } = useGetWhatsNewFeatures({
    query: {
      // Do not execute the React Query call by default when the page loads
      enabled: false,
    },
  })

  return async (): Promise<boolean> => {
    try {
      if (
        !isFeatureEnabled('profile.deliveryPreferences') ||
        !isFeatureEnabled('interaction.agreedPlacePreferencePhotoDialog')
      ) {
        return false
      }

      const { data: { features } = {} } = await getWhatsNewFeatures()

      const hasAgreedPlaceFeature = features?.find(
        ({ name, preferences }) => name === 'agreed-place-picture' && (preferences?.length ?? 0) > 0
      )

      return !!hasAgreedPlaceFeature
    } catch {
      return false
    }
  }
}
